/* Verona Tempo r11 (A): phone menu category photos, back to top, header helpers. */
(function () {
  "use strict";
})();
